import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { usePbm2Url } from "@common/hooks";
import { IAuthenticationExternalApi } from "@pbm/registration-policies/contracts/authenticationExternalApi";

export function useFindAuthenticationExternalApi(id: number) {
  const { request } = usePbm2Url();
  return useQuery("id:" + id, async () => {
    const { Rules_findAuthenticationExternalApi } = await request(
      gql`
        query {
          Rules_findAuthenticationExternalApi(
            input: { RegistrationPolicyCode: ${id} }
          ) {
            authenticationExternalApi {
              id
              RegistrationPolicyCode
              url
              method
              token
              header {
                key
                value
              }
              form {
                type
                key
                value
              }
              createdAt
              updatedAt
            }
            errors {
              code
              message
            }
          }
        }
      `
    );

    return Rules_findAuthenticationExternalApi as IAuthenticationExternalApi;
  });
}
